import {coreStore} from '@gongxigames/framework/core/globals';
import {Store} from '@gongxigames/framework/core/fragments/store/Store';
import {GameProvider} from '../../types';
import {FeatureEventData} from '@gongxigames/framework/slotV2/globals';
import {AutoplayOptions} from '@gongxigames/framework/slot';
import {logicStore} from '@gongxigames/framework/slot/services/logic/store';

import {betControlStore} from '@gongxigames/framework/slotV2/services/BetControl/BetControlStore';
import {turboControlStore} from '@gongxigames/framework/slotV2/services/TurboControl/TurboControlStore';
import {safeZoneStore} from '@gongxigames/framework/slotV2/services/SafeZone/safeZoneStore';
import {uiLayoutsStore} from '@gongxigames/framework/slotV2/ui/services/UIPresetConfigProvider/uiLayoutsStore';
import {UIBalanceStore as uiBalanceStore} from '@gongxigames/framework/slotV2/ui/services/UIBalance/UIBalanceStore';
import {soundStore} from '@gongxigames/framework/slotV2/services/sound/SoundStore';
import {uiElementsStore} from '@gongxigames/framework/slotV2/ui/services/UIElementsStates/uiElementsStore';
import {JurisdictionZoneDataStore as jurisdictionZoneDataStore} from '@gongxigames/framework/slotV2/services/JurisdictionZoneData/JurisdictionZoneDataStore';
import {InfoSystemData} from '@gongxigames/framework/slotV2/modules/infoSystem';
import {bigWinStore} from '@gongxigames/framework/slotV2/modules/bigwin/bigWinStore';
import {buyFeatureControlStore} from '@gongxigames/framework/slotV2/services/BuyFeatureBetControl/BuyFeatureControlStore';
import {pickStore} from '@gongxigames/framework/slotV2/modules/pick/pickStore';
import {spinButtonStore} from '@gongxigames/framework/slotV2/ui/services/SpinButton/SpinButtonStore';
import {uiTickerStore} from '@gongxigames/framework/slotV2/ui/services/UITicker/uiTickerStore';
import {anticipatorStore} from '@gongxigames/framework/slotV2/modules/anticipator/anticipatorStore';
import {tumbleReelsStore} from '../../modules/tumbleReels/tumbleReelsStore';

export const slotStore = coreStore.extend({
    slot_gameProvider: Store.signal(undefined as GameProvider),
    slot_isGameStateMachineActive: Store.signal(false),
    isV2SafeZoneSystemActive: Store.signal(false),

    feature_type: Store.signal(null as FeatureEventData | null),
    isAutoplay: Store.signal(false),
    isAutoplayStop: Store.signal(false),
    isAutoplayOptionsPopup: Store.signal(false),
    autoplayOptions: Store.signal(null as AutoplayOptions | null),
    autoplayOptionsBeforeFeature: Store.signal(null as AutoplayOptions | null),
    playerBalanceBeforeStartAutoplay: Store.signal(0),
    infoSystemData: Store.signal(new Map() as Map<symbol, InfoSystemData>),

    /**
     * skip all bonus intro, outro popups
     */
    feature_skipScreensEnabled: Store.signal(false),

    /**
     * close all bonus intro, outro popups after some delay
     */
    feature_autoCloseScreensEnabled: Store.signal(false),

    /**
     * stops autoplay on first bonus win
     */
    feature_autoplayUntilBonusEnabled: Store.signal(true),

    isHoldForTurboMode: Store.signal(false),
    /**
     * flag to understand is UI fully disabled or no, using flag to cover case when game for example
     * in FS/Respin/Bonus popup and reality check or error popup appear
     * we stay with propper feature, but change UI state, when flag set to true we return back to feature state
     */
    isDisabledUIMode: Store.signal(false),
    /**
     * for now this used to store, which of info pages (paytable, rules, history) will be opened
     * probably we will re-think this later and have maybe dedicated state to avoid this field
     */
    disabledUIModeDataName: Store.signal(undefined as symbol | undefined),

    stage_isPortrait: Store.signal(true),
    stage_isLandscape: Store.signal(false),

    countOfSkipButtonPressed: Store.signal(0),

    ...uiBalanceStore.asReadonlySignalCollection(),
    ...soundStore.asReadonlySignalCollection(),
    ...uiElementsStore.asReadonlySignalCollection(),
    ...uiLayoutsStore.asReadonlySignalCollection(),
    ...safeZoneStore.asReadonlySignalCollection(),
    ...betControlStore.asReadonlySignalCollection(),
    ...turboControlStore.asReadonlySignalCollection(),
    ...buyFeatureControlStore.asReadonlySignalCollection(),
    ...jurisdictionZoneDataStore.asReadonlySignalCollection(),
    ...spinButtonStore.asReadonlySignalCollection(),
    ...uiTickerStore.asReadonlySignalCollection(),

    ...pickStore.getSignals(),
    ...bigWinStore.getSignals(),
    ...anticipatorStore.getSignals(),
    ...tumbleReelsStore.getSignals(),
    ...logicStore.getSignals()
});

